import { configureStore } from '@reduxjs/toolkit';
import { reducer as applicationSlice } from './applications';
import { reducer as userSlice } from './user';

export const store = configureStore({
  reducer: {
    user: userSlice,
    application: applicationSlice,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
